import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { FiCheckCircle, FiClock, FiXCircle } from 'react-icons/fi';
import { apiRequest } from '../services/api';
export default function PaymentStatus(){
  const {status='estado'}=useParams();
  const [subscription,setSubscription]=useState(null);
  const [featured,setFeatured]=useState(false);
  const [featuredTarget,setFeaturedTarget]=useState('');
  const failed=status==='error';
  useEffect(()=>{
    let active=true;let attempts=0;let timer;
    const propertyId=sessionStorage.getItem('pendingFeaturedPropertyId');
    const projectId=sessionStorage.getItem('pendingFeaturedProjectId');
    const check=async()=>{
      try{
        if((propertyId||projectId)&&!failed){
          const me=await apiRequest('/auth/me');
          if(Number(me?.user?.subscription?.featuredCredits)>0){
            await apiRequest(projectId?`/projects/${projectId}/feature`:`/properties/${propertyId}/feature`,{method:'PUT'});
            if(active)setFeaturedTarget(projectId?'project':'property');
            sessionStorage.removeItem(projectId?'pendingFeaturedProjectId':'pendingFeaturedPropertyId');
            if(active)setFeatured(true);
            return;
          }
        }else{
          const value=await apiRequest('/subscriptions/me');
          if(active)setSubscription(value);
          if(value?.status==='ACTIVE')return;
        }
      }catch{}
      attempts+=1;
      if(active&&attempts<12)timer=setTimeout(check,2500);
    };
    check();
    return()=>{active=false;clearTimeout(timer)};
  },[failed]);
  const confirmed=featured||subscription?.status==='ACTIVE';
  const projectIntent=featuredTarget==='project'||Boolean(sessionStorage.getItem('pendingFeaturedProjectId'));
  return <Page><Card>{confirmed?<FiCheckCircle/>:failed?<FiXCircle/>:<FiClock/>}<h1>{featured?`Tu ${projectIntent?'emprendimiento':'propiedad'} ya está destacado`:confirmed?'Tu plan ya está activo':failed?'El pago no se completó':'Estamos confirmando tu pago'}</h1><p>{featured?'El impulso se aplicó automáticamente a la publicación que elegiste.':confirmed?'Mercado Pago confirmó la operación y Nido desbloqueó tus beneficios.':failed?'Podés volver a intentarlo. No activamos ningún plan ni realizamos cambios en tu cuenta.':'No cierres esta pantalla. Cuando Mercado Pago confirme el cobro, aplicaremos el destaque automáticamente.'}</p><div><Link to={failed?'/client/planes':featured?(projectIntent?'/desarrollador':'/mis-publicaciones'):'/client'}>{failed?'Volver a planes':featured?'Ver mis publicaciones':'Ir a mi panel'}</Link><Link className="quiet" to="/client/facturas">Ver historial</Link></div></Card></Page>
}
const Page=styled.main`min-height:78vh;display:grid;place-items:center;background:#f7f6f1;padding:30px;`;
const Card=styled.section`max-width:650px;text-align:center;background:#fff;border:1px solid #dce4e3;border-radius:28px;padding:clamp(35px,7vw,75px);box-shadow:0 28px 80px rgba(39,58,63,.09);color:#243e45;&>svg{font-size:3.2rem;color:#c66f4e}h1{font-size:clamp(2.3rem,5vw,4rem);line-height:1;margin:22px 0}p{font-size:1.06rem;line-height:1.65;color:#637679}div{display:flex;justify-content:center;gap:10px;flex-wrap:wrap;margin-top:30px}a{padding:14px 20px;border-radius:999px;background:#294e57;color:#fff;text-decoration:none;font-weight:800}.quiet{background:#edf0ec;color:#294e57}`;
